<script lang="ts">
	//Hooks
	import { beforeUpdate, createEventDispatcher, onMount } from 'svelte';
	//Stores
	import { linkStore } from '../WebHooksHelpers/link';
	//Design system components
	import {
		IconButton,
		Input,
		Text,
		Stack,
		ListNumberCard,
		Container,
	} from '@Shelly/shelly-design-system';
	//Services
	import { format } from 'svelte-i18n';
	import { isValidURL } from '../../../../helpers/utilities';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';

	export let smallTextMargin = false;
	export let list = [],
		text = 'Choose another text',
		message = '',
		value = list[list.length - 1],
		showURLError = false;

	const errorText = $format('enter_valid_url', {
		default: 'Invalid URLs: Please enter a valid URL!',
	});

	const dispatch = createEventDispatcher();

	$: listDescription = list[0] !== '' ? message : text;
	$: disableAddButton = list.length > 4;

	const handleDelete = (i) => {
		if (list.length > i && list.length !== 1) {
			list.splice(i, 1);
		} else {
			list.splice(0, 1, undefined);
		}
		value = '';
		list = list;
		dispatch('listChange', list);
	};

	const addField = () => {
		if (list.length < 5) {
			list.push('');
		} else {
			list.push(value);
		}

		return (list = [...new Set(list)]);
	};
	const handleChange = (val, index) => {
		if (list.length !== 0) {
			value = val;
			list.splice(index, 1, value);
		} else {
			value = val;
			list[index] = value;
		}
		list = [...new Set(list)];
		dispatch('listChange', list);
	};
	const handleFocus = (item) => {
		value = item;
	};
	beforeUpdate(() => {
		list.forEach((item, index) => {
			if ($linkStore.length > 0) {
				if (item === value) {
					value += $linkStore;
					linkStore.resetLink();

					list.splice(index, 1, value);
					list = list;
				}
			}
		});
	});
	onMount(() => {
		if (list.length === 0) {
			list = [undefined];
		}
	});
</script>

<Text
	element="h2"
	class={classMap({
		'text-capitalize': true,
		'mb-m': !smallTextMargin,
		'mb-s': smallTextMargin,
	})}
	slot="top"
>
	{listDescription}
</Text>
<Container type="borderDashed">
	{#each list as item, i}
		<ListNumberCard editMode size="s" class="mb-s">
			<Input
				aria-labelledby="input-8wbjrlb"
				bind:value={item}
				label={$format('input_label_enter_url_link', {
					default: 'Enter a URL link',
				})}
				type="text"
				size="m"
				icon="fas fa-link"
				error={showURLError && !isValidURL(item, true) ? errorText : ''}
				on:focus={() => handleFocus(value)}
				on:change={() => handleChange(item, i)}
				on:input={() => {
					showURLError = false;
				}}
				id="input-8wbjrlb"
			/>
			<IconButton
				aria-label={$format('button_delete_webhook', {
					default: 'Button delete webhook',
				})}
				class="ml-s"
				icon="fas fa-trash"
				variant="danger"
				on:click={() => handleDelete(i)}
			/>
		</ListNumberCard>
	{/each}
	<div class="d-flex justify-content-center">
		<IconButton
			icon={'fa-solid fa-plus'}
			variant="secondary"
			disabled={disableAddButton}
			on:click={addField}
		>
			{$format('button_add_url', {
				default: 'Add URL',
			})}
		</IconButton>
	</div>
</Container>
